import { FC } from "react";
import { BrowserRouter, Route, Routes } from "react-router";

import { OverlayContainer, TooltipContainer } from "capitalrx-components-2.0/lib/general";

import {
  FindPharmacies,
  MedicarePrescriptionPaymentPlan,
  Pharmacies,
  PharmacyDetailsPage,
  Plan,
  PlanSelect,
  PrintPharmaciesPage,
} from "@/premium/pages";

export const PremiumRoutes: FC = (): JSX.Element => {
  return (
    <BrowserRouter>
      <OverlayContainer>
        <TooltipContainer>
          <Routes>
            <Route path="/" element={<PlanSelect />} />
            <Route path="/plan" element={<Plan />} />
            <Route path="/plan/medicare-prescription-payment-plan" element={<MedicarePrescriptionPaymentPlan />} />
            <Route path="/plan/find-pharmacies/pharmacies/pharmacy-details" element={<PharmacyDetailsPage />} />
            <Route path="/plan/find-pharmacies/pharmacies" element={<Pharmacies />} />
            <Route path="/plan/find-pharmacies" element={<FindPharmacies />} />
            <Route path="/print-pharmacies" element={<PrintPharmaciesPage />} />
          </Routes>
        </TooltipContainer>
      </OverlayContainer>
    </BrowserRouter>
  );
};
